import './carousel.scss';

// for all page
import '../../components/app/header/header';
import '../../components/app/footer/footer';
import '../../components/app/menu/menu';
import '../../components/sections/member-section/member-section';
import '../../components/app/mobile-menu/mobile-menu';

import '../../components/sections/hero-carousel-page/hero-carousel-page';
import '../../components/sections/more-content/more-content';

import Swiper, { Navigation, Pagination } from 'swiper';
import 'swiper/swiper-bundle.min.css';
import 'swiper/swiper.min.css';
import 'swiper/modules/pagination/pagination.scss';
import 'swiper/modules/navigation/navigation.scss';

Swiper.use([Navigation, Pagination]);

const carouselSlider = new Swiper('.carousel__slider', {
	// mobile-style
	spaceBetween: 20,
	slidesPerView: 1,
	centeredSlides: true,
	loop: false,
	slideClass: 'carousel__slide',

	navigation: {
		nextEl: '.carousel__button--next',
		prevEl: '.carousel__button--prev',
	},
	pagination: {
		el: '.carousel__pagination',
		clickable: true,
		dynamicBullets: true,
		dynamicMainBullets: 3,
	},
	breakpoints: {
		900: {
			spaceBetween: 20,
			slidesPerView: 'auto',
			loop: true,
			// initialSlide: 1,
			centeredSlides: true,
			centeredSlidesBounds: true,
			pagination: {
				dynamicBullets: false,
			},
		},
	},
});
